import React, {useEffect, useLayoutEffect, useState} from 'react';
import {SafeAreaView, View, ActivityIndicator, Image} from 'react-native';

import styles from './styles';
import globalStyles from '../../styles';
import {
  dealer as dealerApi,
  service_request as serviceRequestApi,
} from '../../api/public';
import {DownloadLink, Pressable, Text} from '../../components/controls';
import {PublicContentView} from '../../components/shared';
import Format from '../../lib/format';
import {useDispatch, useSelector} from '../../lib/hooks';
import {setDealer} from '../../actions';
import {apiRoot as publicApiRoot} from '../../api/public/endpoints';
import ChevronLeftIcon from '../../images/md-icons/chevron_left/materialicons/24px.svg';

const Pickup = ({route, navigation}) => {
  const dispatch = useDispatch();
  const request_id = route.params?.request_id;
  const dealer = useSelector((state) => state.dealer);
  const [loading, setLoading] = useState(true);
  const [request, setRequest] = useState({});
  const [imageWidth, setImageWidth] = useState(null);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerLeft: () => (
        <Pressable
          style={{paddingLeft: 12}}
          onPress={() => {
            navigation.navigate('Chat', {request_id});
          }}>
          <ChevronLeftIcon />
        </Pressable>
      ),
      headerTitle: () => (
        <View style={{alignItems: 'center'}}>
          <Text>&nbsp;</Text>
        </View>
      ),
    });
  }, [navigation, request_id]);

  useEffect(() => {
    const fetch = async () => {
      const request = await serviceRequestApi.details(request_id);

      const dealer = await dealerApi.details(request.dealer_id);
      dispatch(setDealer(dealer));
      setRequest(request);
      setLoading(false);
    };

    fetch();
  }, [request_id, navigation, dispatch]);

  const onPhotoLayout = (e) => {
    const {layout} = e.nativeEvent;
    setImageWidth(layout.width);
  };

  const imageHeight = imageWidth ? imageWidth * (186.56 / 414) : null;

  const approved_tasks = request?.tasks?.filter(
    (task) => task.status.code === 'Approved',
  );
  return (
    <SafeAreaView style={globalStyles.mainView}>
      {loading && <ActivityIndicator size="large" color="#231fda" />}
      {!loading && (
        <PublicContentView>
          {{
            content: (
              <>
                <Image
                  onLayout={onPhotoLayout}
                  style={[styles.photo, {height: imageHeight}]}
                  source={{
                    uri: `${publicApiRoot}/dealer/photo/${dealer.id}`,
                  }}
                />
                <View style={[globalStyles.contentView, styles.contentView]}>
                  <View style={styles.article}>
                    <View style={styles.row}>
                      <Text style={globalStyles.xxLarge}>{dealer.name}</Text>
                    </View>
                  </View>
                  <View style={styles.article}>
                    <View style={styles.row}>
                      <Text style={globalStyles.mediumPlus}>Ons adres</Text>
                      <DownloadLink
                        href={`https://maps.google.com?q=${dealer.address} ${dealer.city}`}>
                        Route
                      </DownloadLink>
                    </View>
                    <View style={[styles.row, styles.last]}>
                      <Text>
                        {dealer.address} in {dealer.city}
                      </Text>
                    </View>
                  </View>
                  <View style={styles.article}>
                    <View style={styles.row}>
                      <Text style={globalStyles.mediumPlus}>Opdracht</Text>
                    </View>
                    {approved_tasks.map((task, index) => (
                      <View key={index} style={styles.row}>
                        <Text>{task.component_name ?? task.description}</Text>
                        <Text>{Format.price(task.amount)}</Text>
                      </View>
                    ))}
                    <View style={styles.row}>
                      <View>
                        <Text>Totaal</Text>
                        <Text style={globalStyles.small}>Inclusief BTW</Text>
                      </View>
                      <Text>
                        {Format.price(
                          approved_tasks.reduce((acc, x) => acc + x.amount, 0),
                        )}
                      </Text>
                    </View>
                  </View>
                </View>
              </>
            ),
            footer: null,
          }}
        </PublicContentView>
      )}
    </SafeAreaView>
  );
};

export default Pickup;
